const maxCards = 3
const isMobile = window.screen.width <= 999

let toolbar
let maxReached
let mobileMenuDrawer
let cardCount
let darkOverlay

const commonLegalSymbols = [
  '®', // Registered Trademark
  '&reg;',
  '&#174;',
  '™', // Trademark
  '&trade;',
  '&#8482;',
  '℠', // Service Mark
  '&#8480;'
]

const legalSymbols = commonLegalSymbols.join('|')
const legalRegex = new RegExp(`(${legalSymbols})`, 'ig')

// helper for query selector all
const qsa = (selector, context = document) => {
  return Array.prototype.slice.call(context.querySelectorAll(selector))
}

// get the cards data from local storage or start new
const getLocalStorage = () => {
  return 'compare_cards' in localStorage
    ? JSON.parse(localStorage.getItem('compare_cards'))
    : []
}

// template for toolbar
const addToolBar = () => {
  document.body.insertAdjacentHTML(
    'beforeend',
    `
    <div class="compare-toolbar js-compare-toolbar">
      <div class="compare-toolbar__outer-wrapper">
        <div class="compare-toolbar__inner-wrapper">
          <div class="compare-toolbar__middle js-compare-toolbar__menu +display-flex">
            <div class="compare-toolbar__top js-compare-toolbar__max-reached">
              <button class="compare-toolbar__close-button js-compare-toolbar__close-button" type="button">Close</button>
                <div class="+width-full compare-toolbar__max-reached">
                  <div class="+width-full alert --error " role="alert">
                    <div class="alert__icon icon --icon-xs +mg-right">
                      <svg
                        class="icon__glyph"
                        width="18px"
                        height="16px"
                        viewBox="0 0 18 16"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>Error Icon</title>
                        <g id="Error-Icon" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="Alerts" transform="translate(-249.000000, -743.000000)" fill="#D71919" fill-rule="nonzero">
                            <g id="Icon--/-error" transform="translate(246.000000, 739.000000)">
                              <path
                                d="M12.7429924,4.50015598 L20.6199658,18.1430743 C20.8961143,18.6213634 20.7322469,19.2329559 20.2539577,19.5091043 C20.1019359,19.5968767 19.9294877,19.6430853 19.7539468,19.6430853 L4,19.6430853 C3.44771525,19.6430853 3,19.19537 3,18.6430853 C3,18.4675443 3.04620853,18.2950961 3.13398094,18.1430743 L11.0109543,4.50015598 C11.2871028,4.02186686 11.8986952,3.85799946 12.3769844,4.1341479 C12.528995,4.22191386 12.6552265,4.34814533 12.7429924,4.50015598 Z M4,18.6430853 L19.7539468,18.6430853 L11.8769734,5.00016697 L4,18.6430853 Z M11.8769734,17.3930853 C11.3246886,17.3930853 10.8769734,16.94537 10.8769734,16.3930853 C10.8769734,15.8408005 11.3246886,15.3930853 11.8769734,15.3930853 C12.4292581,15.3930853 12.8769734,15.8408005 12.8769734,16.3930853 C12.8769734,16.94537 12.4292581,17.3930853 11.8769734,17.3930853 Z M11.874352,9.39308529 C12.4149364,9.39308529 12.8531666,9.83131554 12.8531666,10.3718999 C12.8531666,10.4060439 12.8513801,10.4401645 12.8478143,10.4741218 L12.4975223,13.8099632 C12.4627165,14.1414205 12.183241,14.3930853 11.8499612,14.3930853 C11.5175168,14.3930853 11.2395589,14.1403454 11.2080355,13.8093989 L10.8904425,10.4751678 C10.8386826,9.93176964 11.2372342,9.44929864 11.7806324,9.39753869 C11.8117842,9.39457144 11.8430593,9.39308529 11.874352,9.39308529 Z"
                                id="Combined-Shape">                                              
                              </path>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div class="alert__text"><p class="+type-body-one +mg-bottom-none +fg-slate compare-toolbar__max-reached-text">Remove a card to add another to compare</p></div>
                  </div>
                </div>
              
              </div>
            <div class="compare-toolbar__line-up js-compare-toolbar__line-up"></div>
          </div>
          <div class="compare-toolbar__bottom">
            <div class="compare-toolbar__menu-button js-compare-toolbar__menu-button">
              <div class="compare-toolbar__card-count js-compare-toolbar__card-count"></div>
              <img class="compare-toolbar__menu-button-img" src="${window.assetUrl}/img/credit-cards/compare-toolbar-card-icon.png" alt="">
            </div>
            <button class="compare-toolbar__compare-button button --primary +display-flex +align-items-center" type="button" onclick="goToCompareHub()">Compare</button>
            <button class="compare-toolbar__clear-button js-compare-toolbar__clear-button +type-body-one" type="button" onclick="clearAll()">Clear</button>
          </div>
        </div>
      </div>
    </div>
    <div class="dark-overlay js-dark-overlay"></div>`
  )
}

// hide the mobile sticky banner
const disableMobileStickyBanner = () => {
  const stickyBanner = document.querySelector(
    '.sticky-banner .sticky-banner-wrapper.--shown'
  )
  if (stickyBanner) {
    stickyBanner.classList.remove('--shown')
  }
}

const disableMobileToolTips = () => {
  qsa('.compare-toolbar__tooltip').forEach(tooltip => {
    tooltip.firstElementChild.classList.remove('tooltip__trigger')
    tooltip.firstElementChild.removeAttribute('data-tooltip')
  })
}

const updateMobileCardCount = cards => {
  cardCount = document.querySelector('.js-compare-toolbar__card-count')

  return cards.length <= maxCards
    ? (cardCount.textContent = cards.length)
    : (cardCount.textContent = maxCards)
}

const disableToolbar = () => {
  // if no cards shut it all down!
  toolbar.classList.remove('is-active')
  darkOverlay.classList.remove('is-active')
  mobileMenuDrawer.classList.remove('is-open')
}

const disableCheckboxes = () => {
  qsa('.js-form-checkbox--compare * .form-checkbox__input').forEach(
    checkbox => {
      if (!checkbox.checked) {
        checkbox.parentElement.classList.add('is-disabled')
        checkbox.disabled = true
      }
    }
  )
}

const enableCheckboxes = () => {
  qsa('.js-form-checkbox--compare * .form-checkbox__input').forEach(
    checkbox => {
      checkbox.parentElement.classList.remove('is-disabled')
      checkbox.disabled = false
    }
  )
}

const openMaxCardsAlert = () => {
  // if there are too many cards, display the warning message
  maxReached.classList.add('is-active')
  mobileMenuDrawer.classList.toggle('is-open')
  darkOverlay.classList.toggle('is-active')

  // trigger 5 second timer, only for desktop
  if (window.screen.width >= 999) {
    setTimeout(() => {
      maxReached.classList.remove('is-active')
    }, 5000)
  }
}

// finds a match by card title of a card on a category page, returns a card Id
const matchByCardTitleOnPage = card => {
  let allCardTitlesFromPage = []

  // returns a NodeList. Can't get textContent directly
  const allCardTitlesNodeList = document.querySelectorAll(
    '.js-product-box__title'
  )

  // remove any of the legal symbols and lowercase
  allCardTitlesNodeList.forEach(cardTitle => {
    allCardTitlesFromPage.push(
      cardTitle.textContent.replace(legalRegex, '').toLowerCase()
    )
  })

  // remove any of the legal symbols and lowercase
  const cleanCardTitle = card.cardTitle.replace(legalRegex, '').toLowerCase()

  // try to find a title match on the page and get it's index
  const index = allCardTitlesFromPage.findIndex(
    cardTitle => cardTitle === cleanCardTitle
  )

  // get the corresponding Id and return it
  if (index > -1) {
    const cardId = document
      .querySelectorAll('.js-product-box')
      [index].getAttribute('data-product-id')

    return { cardId: cardId }
  }
}

const matchByCardTitleInData = (card, cardsFromData) => {
  let cardsFromDataCopy = []

  // remove any of the legal symbols and lowercase
  cardsFromData.forEach(card => {
    cardsFromDataCopy.push(card.cardTitle.replace(legalRegex, '').toLowerCase())
  })

  // remove any of the legal symbols and lowercase
  const cleanCardTitle = card.cardTitle.replace(legalRegex, '').toLowerCase()

  // try to find a title match in the array and get it's index
  const index = cardsFromDataCopy.findIndex(
    cardTitle => cardTitle === cleanCardTitle
  )

  // get the corresponding Id and return it
  if (index > -1) {
    return index
  }
}

const dynamicallyCheckTheBoxes = cards => {
  // check the boxes that should be checked
  cards.slice(0, maxCards).forEach(card => {
    // FC-207 | if there is a card on the page that has the same title as one we have in localStorage, but different id, check the checkbox anyway
    // we don't want users to be able to add two identical cards to compare
    const titleMatch = matchByCardTitleOnPage(card)
    card.legacyId = titleMatch ? titleMatch.cardId : card.legacyId
    let checkbox = document.querySelector(`#form-checkbox-${card.legacyId}`)
    let label = document.querySelector(
      `label[for='form-checkbox-${card.legacyId}']`
    )

    if (checkbox) {
      checkbox.checked = true
      checkbox.disabled = false
      checkbox.parentElement.classList.remove('is-disabled')
    }

    if (label) {
      label.childNodes[4].textContent = 'Added to compare'
    }
  })
}

// since this script can be initiated by a checkbox now, we need a way to 'scan' the page for the first checked box after initiation
const wakeUpFromClick = () => {
  qsa('.js-form-checkbox--compare * .form-checkbox__input').forEach(
    checkbox => {
      if (checkbox.checked) {
        setTimeout(() => {
          addCard(getCardInfo(checkbox))
        }, 0)
      }
    }
  )
}

// template for individual card in toolbar
const buildLineUp = cards => {
  const lineUp = document.querySelector('.js-compare-toolbar__line-up')
  const compareButton = document.querySelector(
    '.compare-toolbar__compare-button'
  )

  // always be clearing
  lineUp.innerHTML = ''

  // throw down 3 placeholders
  for (let i = 0; i < maxCards; i++) {
    lineUp.insertAdjacentHTML(
      'beforeend',
      '<div class="compare-toolbar__card compare-toolbar__placeholder"></div>'
    )
  }

  // replace the placeholders with cards
  cards.slice(0, maxCards).forEach((card, i) => {
    const placeholder = document.querySelectorAll('.compare-toolbar__card')[i]

    placeholder.outerHTML = `
      <div class="compare-toolbar__card +mg-right-sm--md +pd-right-sm--md">
        <div class="tooltip compare-toolbar__tooltip" data-tooltip="container" data-tooltip-type="clickable">
          <div
            class="tooltip__trigger"
            data-tooltip="trigger"
            aria-controls="tooltip-${card.legacyId}"
            aria-expanded="false"
          >
            <div class="+display-flex +align-items-center">
                <img class="compare-toolbar__card-art" src="${card.cardArt}" alt="${card.cardTitle}">
                <span class="compare-toolbar__card-title">${card.cardTitle}</span>
            </div>
            <div
              class="tooltip__content --pos-center +text-center +pd-bottom-md"
              id="tooltip-${card.legacyId}"
              role="tooltip"
              data-tooltip="content"
              aria-hidden="true"
              style="display: none;"
            >
              <div class="tooltip__body +type-body-three">
                <div class="tooltip__arrow"></div>
                ${card.cardTitle}
              </div>
            </div>
          </div>
        </div>
        <button class="card__remove-button js-card__remove-button" data-product-id="${card.legacyId}" data-product-name="${card.cardTitle}" type="button">Remove Card</button>
      </div>`
  })

  // disable the compare button and show a notification if there's only one card
  if (cards.length <= 1) {
    lineUp.insertAdjacentHTML(
      'beforeend',
      '<span class="compare-toolbar__add-more-text +type-body-three +mg-right-md +mg-left-sm +pd-left-sm">Add up to 3 cards to compare</span>'
    )
    compareButton.disabled = true
  } else {
    compareButton.disabled = false
  }
}

// on page load
const init = () => {
  const data = getLocalStorage()
  const cards = data.cards ? data.cards : []

  addToolBar()

  toolbar = document.querySelector('.js-compare-toolbar')
  maxReached = document.querySelector('.js-compare-toolbar__max-reached')
  mobileMenuDrawer = document.querySelector('.js-compare-toolbar__menu')
  darkOverlay = document.querySelector('.js-dark-overlay')

  wakeUpFromClick()

  if (cards.length) {
    updateMobileCardCount(cards)
    buildLineUp(cards)
    updateTooltips()
    dynamicallyCheckTheBoxes(cards)
    toolbar.classList.add('is-active')

    if (isMobile) {
      disableMobileStickyBanner()
      disableMobileToolTips()
    }
  }

  if (cards.length >= maxCards) {
    disableCheckboxes()
  }
}

// helper to update Classy tooltips (used for toolbar card titles on desktop view) without a refresh
const updateTooltips = () => {
  // eslint-disable-next-line
  !function(t){var e={};function o(r){if(e[r])return e[r].exports;var n=e[r]={i:r,l:!1,exports:{}};return t[r].call(n.exports,n,n.exports,o),n.l=!0,n.exports}o.m=t,o.c=e,o.d=function(t,e,r){o.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},o.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(o.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var n in t)o.d(r,n,function(e){return t[e]}.bind(null,n));return r},o.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return o.d(e,"a",e),e},o.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},o.p="",o(o.s=0)}([function(t,e,o){"use strict";o.r(e);const r=t=>{if(t||console.error("tooltip.js | tooltipContent is not defined"),t.hasAttribute("style")){const e=t.getAttribute("style");t.setAttribute("style","display: none;"===e?"display: block;":"display: none;")}else t.setAttribute("style","display: none")},n=t=>{if(t||console.error("tooltip.js | tooltipContent is not defined"),t.hasAttribute("aria-hidden")){const e=t.getAttribute("aria-hidden");t.setAttribute("aria-hidden","true"===e?"false":"true")}else t.setAttribute("aria-hidden","true")},i=t=>{if(t||console.error("tooltip.js | tooltipTrigger is not defined"),t.hasAttribute("aria-expanded")){const e=t.getAttribute("aria-expanded");t.setAttribute("aria-expanded","false"===e?"true":"false")}else t.setAttribute("aria-expanded","false")},l=t=>{t||console.error("tooltip.js | selector is not defined");const e=document.querySelectorAll(t);e.length>0&&e.forEach(t=>{(t=>{const e=t.querySelector('.compare-toolbar__tooltip [data-tooltip="trigger"]'),o=t.querySelector('.compare-toolbar__tooltip [data-tooltip="content"]');t.contains(e)?["mouseover","focus","mouseout","blur","touchstart"].forEach(t=>{e.addEventListener(t,()=>{r(o),n(o),i(e)},{passive:"touchstart"===t})}):console.error("tooltip.js | element does not container tooltipTrigger")})(t)})};(()=>{l('.compare-toolbar__tooltip[data-tooltip="container"]')})()}]);
}

const productClicked = (card, productClickedParams) => {
  // fire tagular event
  if (!window.tagular) return
  window.tagular('beam', 'ProductClicked', {
    '@type': 'redventures.ecommerce.v1.ProductClicked',
    product: {
      productId: card.legacyId,
      category: card.categoryId,
      brand: card.issuer,
      name: card.cardTitle,
      location: 'GRID',
      text: productClickedParams.text
    },
    actionOutcome: productClickedParams.actionOutcome
  })
}

// add a card
const addCard = ({ card, checkboxLabel }) => {
  const data = getLocalStorage()
  const cards = data.cards ? data.cards : []

  if (cards.length < maxCards) {
    checkboxLabel.childNodes[4].textContent = 'Added to compare'
  }

  if (cards.length >= maxCards) {
    openMaxCardsAlert()
  }

  if (cards.length > maxCards) {
    cards.fill(card, maxCards)
  }

  if (cards.length <= maxCards) {
    cards.push(card)
  }

  if (cards.length === maxCards) {
    disableCheckboxes()
  }

  // add the checked card to data.
  localStorage.setItem(
    'compare_cards',
    JSON.stringify({
      cards: cards,
      from: 'compare_toolbar',
      grid_shown: false
    })
  )

  // make the toolbar visible
  toolbar.classList.add('is-active')
  buildLineUp(cards)

  if (isMobile) {
    disableMobileStickyBanner()
    disableMobileToolTips()
    updateMobileCardCount(cards)
  } else {
    updateTooltips()
  }

  productClicked(card, { text: 'ADD TO COMPARE', actionOutcome: 'OPEN' })
}

const handleGhostCardSwap = (filteredCards, removedCardsCheckbox) => {
  // handle the checking and enabling of the ghostcard's checkbox
  // also handle the disabling of the checkbox of the removed card
  const ghostCard = filteredCards.slice(-1)[0] // get the last card
  // take the last card and check it's specific checkbox
  const ghostCardCheckbox = document.querySelector(
    `#form-checkbox-${ghostCard.legacyId}`
  )
  const ghostCardLabel = document.querySelector(
    `label[for='form-checkbox-${ghostCard.legacyId}']`
  )

  if (ghostCardCheckbox) {
    ghostCardCheckbox.checked = true
    ghostCardCheckbox.disabled = false
    ghostCardCheckbox.parentElement.classList.remove('is-disabled')
  }
  if (ghostCardLabel) {
    ghostCardLabel.childNodes[4].textContent = 'Added to compare'
  }

  if (removedCardsCheckbox) {
    removedCardsCheckbox.parentElement.classList.add('is-disabled')
    removedCardsCheckbox.disabled = true
  }
}

// remove a card
const removeCard = (removedCard, from) => {
  const data = getLocalStorage()
  const card = removedCard.card
  let cards = data.cards
  let titleMatch
  let cardId

  switch (from) {
    case 'fromToolbar':
      titleMatch = matchByCardTitleOnPage(card)
      cardId = titleMatch ? titleMatch.cardId : card.legacyId
      cards = cards.filter(c => {
        return card.legacyId !== c.legacyId
      })
      break
    case 'fromCheckbox':
      titleMatch = matchByCardTitleInData(card, cards)
      cardId = card.legacyId
      cards.splice(titleMatch, 1)
      break
  }

  // manually uncheck the specific card
  const removedCardsCheckbox = document.querySelector(
    `#form-checkbox-${cardId}`
  )
  const removedCardsCheckboxLabel = document.querySelector(
    `label[for='form-checkbox-${cardId}']`
  )

  if (removedCardsCheckbox) {
    removedCardsCheckbox.checked = false
  }

  if (removedCardsCheckboxLabel) {
    removedCardsCheckboxLabel.childNodes[4].textContent = 'Add to compare'
  }

  // remove the unchecked card from local storage
  localStorage.setItem(
    'compare_cards',
    JSON.stringify({ ...data, cards: cards })
  )

  if (!cards.length) {
    disableToolbar()
  } else if (cards.length === maxCards - 1) {
    enableCheckboxes()
  } else if (cards.length === maxCards) {
    handleGhostCardSwap(cards, removedCardsCheckbox)
  }

  buildLineUp(cards)

  if (isMobile) {
    updateMobileCardCount(cards)
  } else {
    updateTooltips()
  }

  maxReached.classList.remove('is-active')
  productClicked(card, { text: 'REMOVE TO COMPARE', actionOutcome: 'CLOSE' })
}

const getCardInfo = e => {
  const card = {}
  let thisProductBox

  if (e.target) {
    thisProductBox = e.target.closest('.js-product-box')
  } else {
    thisProductBox = e.closest('.js-product-box')
  }

  card.legacyId = thisProductBox.getAttribute('data-product-id')
  card.cardArt = thisProductBox
    .querySelector('.featured-cards__image')
    .getAttribute('src')
  card.cardTitle = thisProductBox.querySelector(
    '.js-product-box__title'
  ).textContent
  card.issuer = thisProductBox.getAttribute('data-issuer-name')
  card.categoryId = thisProductBox.getAttribute('data-category-id')

  const checkboxLabel = thisProductBox.querySelector(
    `label[for="form-checkbox-${card.legacyId}"]`
  )

  return { card, checkboxLabel }
}

// clicking the clear all cards button in the toolbar
window.clearAll = () => {
  localStorage.removeItem('compare_cards')

  // uncheck all the checkboxes
  qsa('.js-form-checkbox--compare * .form-checkbox__input').forEach(
    checkbox => {
      checkbox.checked = false
    }
  )
  // reset all the checkbox labels
  qsa('.js-form-checkbox--compare > label').forEach(label => {
    label.childNodes[4].textContent = 'Add to compare'
  })

  enableCheckboxes()
  disableToolbar([])

  // fire tagular event
  if (!window.tagular) return
  window.tagular('beam', 'ElementClicked', {
    '@type': 'redventures.usertracking.v3.ElementClicked',
    webElement: {
      elementType: 'BUTTON',
      location: 'FOOTER',
      position: 'BOTTOM',
      text: 'CLEAR'
    },
    actionOutcome: 'CLOSE'
  })
}

window.goToCompareHub = () => {
  window.open('/finance/credit-cards/compare/', '_self')

  // fire tagular event
  if (!window.tagular) return
  window.tagular('beam', 'ElementClicked', {
    '@type': 'redventures.usertracking.v3.ElementClicked',
    webElement: {
      elementType: 'BUTTON',
      location: 'FOOTER',
      position: 'BOTTOM',
      text: 'COMPARE'
    },
    actionOutcome: 'CLOSE'
  })
}

//
// Event Listeners
//

// clicking a checkbox
document.addEventListener(
  'click',
  e => {
    // If the clicked element doesn't have the right selector, bail
    if (
      !e.target.matches('.form-checkbox__input') ||
      e.target.matches('.form-checkbox') ||
      !e.target.closest('.js-form-checkbox--compare')
    ) {
      return
    }
    const { checked } = e.target

    // logic to decide whether to add or remove a card
    if (checked) {
      addCard(getCardInfo(e))
    } else {
      removeCard(getCardInfo(e), 'fromCheckbox')
    }
  },
  false
)

// clicking the remove card button from the toolbar
document.addEventListener(
  'click',
  e => {
    // If the clicked element doesn't have the right selector, bail
    if (!e.target.matches('.js-card__remove-button')) return

    const card = {}
    card.legacyId = e.target.getAttribute('data-product-id')
    card.cardTitle = e.target.getAttribute('data-product-name')

    removeCard({ card }, 'fromToolbar')
  },
  false
)

// Toggle mobile menu
document.addEventListener(
  'click',
  e => {
    // If the clicked element doesn't have the right selector, bail
    if (
      !e.target.matches(
        '.js-compare-toolbar__menu-button, .compare-toolbar__menu-button-img, .js-dark-overlay, .js-compare-toolbar__close-button'
      )
    )
      return

    mobileMenuDrawer.classList.toggle('is-open')
    darkOverlay.classList.toggle('is-active')
  },
  false
)

// Handle clicks on disabled checkboxes and show the "max cards reached" popup.
document.addEventListener(
  'click',
  e => {
    if (
      e.target.matches('.js-form-checkbox--compare .form-checkbox.is-disabled')
    ) {
      addCard(getCardInfo(e))
    }
  },
  false
)

// only initialize when cohesion is ready
window.cohesion('ready', function() {
  init()
})
